"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.colors = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var colors = {
  accent: 'rgb(247, 8, 72)',
  accent_alpha: 'rgba(247, 8, 72, 0.1)',
  accent_pro: 'rgb(135, 11, 243)',
  accent_pro_alpha: 'rgba(135, 11, 243, 0.1)',
  chart_bg: 'rgba(0, 0, 0, 0.1)',
  chart_tips: 'rgba(0, 0, 0, 0.4)',
  black_alpha: 'rgba(0, 0, 0, 0.8)',
  pristine: '#ffffff',
  pristine_alpha: 'rgba(255, 255, 255, .5)',
  transparent: 'transparent',
  grey: 'rgb(122,122,122)',
  green: 'rgb(60,196,124)'
};
exports.colors = colors;
var scale = {
  xs: '10px',
  s: '12px',
  r: '15px',
  l: '18px',
  xl: '24px',
  xxl: '66px'
};
var spaces = {
  xs: '4px',
  s: '6px',
  r: '8px',
  l: '12px',
  xl: '20px'
};
var layers = {
  base: 1,
  mid: 2,
  top: 3,
  max: 10
};

var g = function g(obj) {
  return function (k) {
    return obj[k];
  };
};

var capitalize = function capitalize(_ref) {
  var _ref2 = _toArray(_ref),
      first = _ref2[0],
      rest = _ref2.slice(1);

  return first ? first.toUpperCase() + rest.join('') : '';
};

var font = function font(k) {
  return {
    fontSize: g(scale)(k)
  };
};

var elevation = function elevation(k) {
  return {
    zIndex: g(layers)(k)
  };
};

var spacing = function spacing(domain) {
  return function (k) {
    return _defineProperty({}, domain, g(spaces)(k));
  };
};

var spacing_axis = function spacing_axis(axis) {
  return function (domain) {
    return function (k) {
      var _ref5;

      if (axis === 'y') {
        var _ref4;

        return _ref4 = {}, _defineProperty(_ref4, "".concat(domain, "Top"), g(spaces)(k)), _defineProperty(_ref4, "".concat(domain, "Bottom"), g(spaces)(k)), _ref4;
      }

      return _ref5 = {}, _defineProperty(_ref5, "".concat(domain, "Left"), g(spaces)(k)), _defineProperty(_ref5, "".concat(domain, "Right"), g(spaces)(k)), _ref5;
    };
  };
};

var spacing_direction = function spacing_direction(direction) {
  return function (domain) {
    return function (k) {
      return _defineProperty({}, "".concat(domain).concat(capitalize(direction)), g(spaces)(k));
    };
  };
};

var padded = function padded(k) {
  return spacing('padding')(k);
};

var paddedY = function paddedY(k) {
  return spacing_axis('y')('padding')(k);
};

var margin = function margin(k) {
  return spacing('margin')(k);
};

var marginRight = function marginRight(k) {
  return spacing_direction('right')('margin')(k);
};

var flex_box = function flex_box(direction) {
  return function (justify) {
    return function (align) {
      return {
        display: 'flex',
        flexDirection: direction,
        justifyContent: justify,
        alignItems: align
      };
    };
  };
};

var box = {
  col_center: function col_center(align) {
    return flex_box('column')('center')(align);
  },
  row_center: function row_center(align) {
    return flex_box('row')('center')(align);
  },
  col_start: function col_start(align) {
    return flex_box('column')('flex-start')(align);
  },
  row_start: function row_start(align) {
    return flex_box('row')('flex-start')(align);
  },
  row_between: function row_between(align) {
    return flex_box('row')('space-between')(align);
  },
  col_between: function col_between(align) {
    return flex_box('column')('space-between')(align);
  },
  stretch: {
    display: 'flex',
    alignSelf: 'stretch'
  },
  fill: {
    width: '100%',
    flex: '1 1 auto!important'
  }
};
var txt = {
  bold: {
    fontWeight: 600
  },
  numbers: {
    fontVariantNumeric: 'tabular-nums'
  },
  truncate_sx: function truncate_sx(w) {
    return {
      display: 'block',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: "".concat(w, "px")
    };
  },
  uppercase: {
    fontSize: '0.9rem',
    letterSpacing: '0.05rem',
    textTransform: 'uppercase',
    fontWeight: 500
  },
  call_to_action: {
    color: colors.accent,
    fontSize: font('xl'),
    textAlign: 'center'
  }
};
var pinned = {
  position: 'absolute',
  top: ' 50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: layers.max
};

var _default = _objectSpread({}, box, {}, txt, {
  elevation: elevation,
  marginRight: marginRight,
  padded: padded,
  paddedY: paddedY,
  pinned: pinned,
  font: font
});

exports["default"] = _default;